/**
 * PagesStep.jsx
 * =============
 * Page editing for setup wizard
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import PageBuilder from '../PageBuilder';

const PagesStep = () => {
  const { appName } = useParams();

  return (
    <SetupWizard currentStepKey="pages">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px',
        marginBottom: '20px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          📄 Design Your Pages
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Customize your pages, edit text, add components, and make it your own.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Click on any component to edit its properties</li>
            <li>Use the left panel to add new components</li>
            <li>Preview your changes in real-time on the right</li>
            <li>Don't forget to save your changes!</li>
          </ul>
        </div>
      </div>

      {/* Embed PageBuilder */}
      <PageBuilder appName={appName} />
    </SetupWizard>
  );
};

export default PagesStep;
























